import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CancelEventForm } from '../forms/CancelEventForm';

type CancelEventModalProps = {
  isOpen: boolean;
  onClose: () => void;
  eventUuid: string;
  substitutionComment: string;
};

export const CancelEventModal = ({ isOpen, onClose, eventUuid, substitutionComment }: CancelEventModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal loading={loading} width='s' title={t('substitutions.cancelEvent')} isOpen={isOpen} onRequestClose={onClose}>
      <CancelEventForm
        eventUuid={eventUuid}
        substitutionComment={substitutionComment}
        onLoad={setLoading}
        onClose={onClose}
      />
    </Modal>
  );
};
